<template>
  <b-sidebar
    :id="id"
    no-header
    backdrop-variant="dark"
    backdrop
    right
    shadow
    :width="width"
    class="al-sidebar"
    z-index="10"
    :aria-label="title"
    :visible="visible"
    :no-close-on-backdrop="noCloseOnBackdrop"
    test-id="al-sidebar"
    @change="change"
  >
    <template v-if="this.$slots.footer" v-slot:footer="{ hide }">
      <slot v-if="!hide" name="footer" />
    </template>

    <template v-slot:default="{ hide }">
      <div class="al-side__content">
        <al-section-hero
          :title="title"
          :placeholder="placeholder"
          icon="cross-inverted"
          :editable="editableTitle"
          size="md"
          @blur="onBlur"
          @to="hide"
        ></al-section-hero>
        <slot />
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar } from 'bootstrap-vue';
import AlSectionHero from '../../shared/header/section-hero/AlSectionHero.vue';

export default {
  components: {
    BSidebar,
    AlSectionHero
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: { type: Boolean, default: false },
    id: { type: String, required: true },
    title: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    editableTitle: { type: Boolean, default: false },
    width: { type: String, default: '580px' },
    noCloseOnBackdrop: {
      type: Boolean,
      default: true
    }
  },

  mounted() {
    if (this.visible) {
      this.freezeBodyPage(200);
      return;
    }
    this.unfreezeBodyPage(200);
  },
  methods: {
    change(visible) {
      if (visible) {
        this.freezeBodyPage();
      } else {
        this.unfreezeBodyPage();
      }
      this.$emit('change', visible);
    },
    freezeBodyPage(time = 0) {
      setTimeout(() => {
        document.querySelector('html').classList.add('al-open-sidebar');
      }, time);
    },
    unfreezeBodyPage(time = 200) {
      setTimeout(() => {
        document.querySelector('html').classList.remove('al-open-sidebar');
      }, time);
    },
    onBlur(value) {
      this.$emit('blur', value);
    }
  }
};
</script>

<style lang="scss">
/** variables */
$max-width-sidebar: 580px;
$p-sidebar: 0 80px;
$p-sidebar-body: 40px 0;

html,
body {
  &.al-open-sidebar {
    overflow: hidden !important;
    padding-right: 15px;
  }
}

.al-sidebar {
  border: 0;
  max-width: $max-width-sidebar;

  .m_auto {
    padding: $p-sidebar;
  }

  .al-section-hero {
    padding-bottom: 28px;
  }

  .al-side__content {
    padding: $p-sidebar;
  }

  .b-sidebar {
    .b-sidebar-body {
      height: auto;
      padding: $p-sidebar-body;
      padding-bottom: 150px;
      position: relative;

      .exit-btn {
        cursor: pointer;
        left: -45px;
        position: absolute;
        top: 2.5px;
      }
    }

    &.bg-light {
      background-color: color(white, lighten, 1) !important;
    }
  }

  .b-sidebar-backdrop {
    backdrop-filter: blur(3px);
    opacity: 0.92;
  }

  .al-form__footer {
    padding: $p-sidebar;
  }
}
</style>
